<template>
  <section
    id="services"
    class="overflow-hidden"
  >
    <v-row
      no-gutters
    >
      <v-col
        class="align-content-space-between layout wrap pt-5"
        cols="12"
        md="6"
        :pa-5="$vuetify.breakpoint.smAndDown"
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="10"
          >
            <base-heading>
              Services
            </base-heading>
            <base-text>
              All <strong>prices include HST</strong>. I currently accept <strong>cash or e-transfer</strong> payments.
            </base-text>

            <v-simple-table class="mt-6 mb-10">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Length
                    </th>
                    <th class="text-left">
                      Price
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="service in services"
                    :key="service.length"
                  >
                    <td>{{ service.length }} Minutes</td>
                    <td>{{ service.price }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>

            <base-subheading>
              Benefits of Massage Therapy
            </base-subheading>

            <div class="text-left">
              <base-text class="mb-5">
                Massage is generally considered part of integrative medicine. It's increasingly being offered along with standard treatment for a wide range of medical conditions and situations.
              </base-text>

              <base-text class="mb-5">
                Massage benefits can include:
              </base-text>

              <base-text class="mb-5">
                <ul>
                  <li>Reducing stress and increasing relaxation</li>
                  <li>Reducing pain and muscle soreness and tension</li>
                  <li>Improving circulation, energy and alertness</li>
                  <li>Lowering heart rate and blood pressure</li>
                  <li>Improving immune function</li>
                </ul>
              </base-text>

              <base-text class="mb-5">
                While more research is needed to confirm the benefits of massage, some studies have found massage may also be helpful for:
              </base-text>

              <base-text class="mb-5">
                <ul>
                  <li>Anxiety</li>
                  <li>Digestive disorders</li>
                  <li>Fibromyalgia</li>
                  <li>Headaches</li>
                  <li>Insomnia related to stress</li>
                  <li>Low back pain</li>
                  <li>Myofascial pain syndrome</li>
                  <li>Nerve pain</li>
                  <li>Soft tissue strains or injuries</li>
                  <li>Sports injuries</li>
                  <li>Temporomandibular joint pain</li>
                  <li>Upper back and neck pain</li>
                </ul>
              </base-text>

              <base-text class="mb-5">
                Beyond the benefits for specific conditions or diseases, some people enjoy massage because it often produces feelings of caring, comfort and connection.
              </base-text>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        class="hidden-sm-and-down"
        md="6"
      >
        <v-img
          :src="require('@/assets/services.jpg')"
          height="100%"
        />
      </v-col>
    </v-row>
  </section>
</template>

<script>
  export default {
    name: 'Services',

    data: () => ({
      services: [
        {
          length: '30',
          price: '$90',
        },
        {
          length: '45',
          price: '$120',
        },
        {
          length: '60',
          price: '$140',
        },
        {
          length: '75',
          price: '$170',
        },
      ],
    }),
  }
</script>
